(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["monte-seu-combo"] && !Shopify.designMode) return;
  try {
    function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? "," : thousands;
      decimal = decimal == null ? "." : decimal;
      if (isNaN(number) || number == null) return "0";
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);
    var value = "";
    switch (match ? match[1] : "amount") {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  /* Progressbar baseada em quantidade total selecionada */
  class BundleProgressbar extends HTMLElement {
    connectedCallback() {
      this.fill = this.querySelector(".progress-fill");
      this.dot = this.querySelector(".progress-dot");
      this.tierCols = Array.from(this.querySelectorAll(".progress-tier"));

      this.steps = Array.from(this.querySelectorAll(".progress-step"))
        .map((el) => ({
          el: el,
          qty: parseInt(el.dataset.stepQty, 10),
          position: parseFloat(el.style.getPropertyValue("--position")) || 0,
        }))
        .sort((a, b) => a.qty - b.qty);

      this.update(0);
    }

    update(totalQty) {
      if (!this.steps || !this.steps.length) return;

      var first = this.steps[0];
      var last = this.steps[this.steps.length - 1];
      var percent = this._percentForQty(totalQty, first, last);

      this.steps.forEach((s) => {
        s.el.classList.toggle("is-active", totalQty >= s.qty);
      });

      if (this.fill) this.fill.style.width = percent + "%";
      if (this.dot) {
        this.dot.style.left = percent + "%";
        this.dot.style.opacity = totalQty > 0 ? "1" : "0";
      }

      // faixa atual = maior faixa alcançada
      var currentQty = 0;
      this.steps.forEach((s) => {
        if (totalQty >= s.qty) currentQty = s.qty;
      });
      this.tierCols.forEach((col) => {
        col.classList.toggle("is-current", parseInt(col.dataset.tierQty, 10) === currentQty && totalQty > 0);
      });
    }

    _percentForQty(qty, first, last) {
      if (qty <= 0) return 0;
      if (qty <= first.qty) {
        return first.qty === 0 ? first.position : (qty / first.qty) * first.position;
      }
      if (qty >= last.qty) return last.position;
      for (var i = 0; i < this.steps.length - 1; i++) {
        var a = this.steps[i];
        var b = this.steps[i + 1];
        if (qty >= a.qty && qty <= b.qty) {
          var t = (qty - a.qty) / (b.qty - a.qty);
          return a.position + t * (b.position - a.position);
        }
      }
      return last.position;
    }
  }
  if (!customElements.get("bundle-progressbar")) {
    customElements.define("bundle-progressbar", BundleProgressbar);
  }

  /* Controlador do combo: seleção por card + add via Cart API */
  class MonteSeuCombo extends HTMLElement {
    connectedCallback() {
      this.basePrice = parseInt(this.dataset.basePrice, 10) || 0;
      this.moneyFormat = this.dataset.moneyFormat || "${{amount}}";
      this.cartAction = this.dataset.cartAction || "cart";
      this.subDiscount = parseFloat(this.dataset.subscriptionDiscount) || 0;
      this.sellingPlanId = this.dataset.sellingPlanId ? Number(this.dataset.sellingPlanId) : null;

      this.progressbar = this.querySelector("bundle-progressbar");
      this.cards = Array.from(this.querySelectorAll(".bundle-card"));
      this.buyBtn = this.querySelector("[data-combo-buy]");
      this.subscribeBtn = this.querySelector("[data-combo-subscribe]");
      this.buyTotalEl = this.querySelector(".buy-total");
      this.subTotalEl = this.querySelector(".subscribe-total");
      this.subCompareEl = this.querySelector(".subscribe-compare");
      this.errorEl = this.querySelector(".combo-error");

      this.tiers = Array.from(this.querySelectorAll(".progress-step"))
        .map((s) => ({ qty: parseInt(s.dataset.stepQty, 10), discount: parseFloat(s.dataset.discount) || 0 }))
        .sort((a, b) => a.qty - b.qty);

      this.bindEvents();
      this.render();
    }

    bindEvents() {
      // delegação para +/-/adicionar
      this.addEventListener("click", (e) => {
        var card = e.target.closest(".bundle-card");
        if (!card) return;
        if (e.target.closest("[data-plus-quantity-cart]")) {
          e.preventDefault();
          this.changeQty(card, 1);
        } else if (e.target.closest("[data-minus-quantity-cart]")) {
          e.preventDefault();
          this.changeQty(card, -1);
        } else if (e.target.closest(".bundle-button")) {
          e.preventDefault();
          this.setQty(card, 1);
        }
      });

      // digitação direta no input
      this.addEventListener("change", (e) => {
        var input = e.target.closest("[data-cart-quantity]");
        var card = e.target.closest(".bundle-card");
        if (input && card) this.setQty(card, parseInt(input.value, 10) || 0);
      });

      if (this.buyBtn) this.buyBtn.addEventListener("click", () => this.addToCart(false));
      if (this.subscribeBtn) this.subscribeBtn.addEventListener("click", () => this.addToCart(true));
    }

    getInput(card) {
      return card.querySelector("[data-cart-quantity]");
    }
    getQty(card) {
      return parseInt(this.getInput(card).value, 10) || 0;
    }

    setQty(card, val) {
      var input = this.getInput(card);
      val = Math.max(0, val);
      if (input.dataset.inventoryQuantity) {
        val = Math.min(val, parseInt(input.dataset.inventoryQuantity, 10));
      }
      input.value = val;
      card.classList.toggle("is-selected", val > 0);
      this.render();
    }

    changeQty(card, delta) {
      this.setQty(card, this.getQty(card) + delta);
    }

    totalQty() {
      return this.cards.reduce((sum, c) => sum + this.getQty(c), 0);
    }

    currentDiscount(qty) {
      var disc = 0;
      this.tiers.forEach((t) => {
        if (qty >= t.qty) disc = t.discount;
      });
      return disc;
    }

    render() {
      var qty = this.totalQty();
      if (this.progressbar && this.progressbar.update) this.progressbar.update(qty);

      var perUnit = Math.round((this.basePrice * (100 - this.currentDiscount(qty))) / 100);
      var buyTotal = perUnit * qty;
      if (this.buyTotalEl) this.buyTotalEl.textContent = formatMoney(buyTotal || this.basePrice, this.moneyFormat);

      // assinatura: desconto sobre o preço base, quantidade selecionada (mín. 1 p/ referência)
      var refQty = qty || 1;
      var subUnit = Math.round((this.basePrice * (100 - this.subDiscount)) / 100);
      if (this.subTotalEl) this.subTotalEl.textContent = formatMoney(subUnit * refQty, this.moneyFormat);
      if (this.subCompareEl) this.subCompareEl.textContent = formatMoney(this.basePrice * refQty, this.moneyFormat);

      var disabled = qty === 0;
      [this.buyBtn, this.subscribeBtn].forEach((b) => {
        if (b) {
          b.disabled = disabled;
          b.classList.toggle("is-disabled", disabled);
        }
      });
      this.clearError();
    }

    buildItems(subscription) {
      var items = [];
      this.cards.forEach((card) => {
        var qty = this.getQty(card);
        if (qty <= 0) return;
        var variant = card.querySelector(".bundle-qty").dataset.variant;
        var item = { id: Number(variant), quantity: qty };
        if (subscription && this.sellingPlanId) item.selling_plan = this.sellingPlanId;
        items.push(item);
      });
      return items;
    }

    async addToCart(subscription) {
      var items = this.buildItems(subscription);
      if (!items.length) return;

      var btn = subscription ? this.subscribeBtn : this.buyBtn;
      btn.classList.add("is-loading");
      btn.disabled = true;

      try {
        var res = await fetch(shopRoot() + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items }),
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || "Não foi possível adicionar ao carrinho.");

        this.dispatchEvent(new CustomEvent("combo:added", { bubbles: true, detail: { items: data.items || data } }));
        await this.afterAdd();
      } catch (err) {
        console.error("[monte-seu-combo]", err);
        this.showError(err.message);
      } finally {
        btn.classList.remove("is-loading");
        btn.disabled = false;
      }
    }

    async afterAdd() {
      if (this.cartAction === "checkout") {
        window.location.href = shopRoot() + "checkout";
        return;
      }
      if (this.cartAction === "cart") {
        window.location.href = shopRoot() + "cart";
        return;
      }
      // drawer: dispara eventos comuns para o tema atualizar/abrir o carrinho
      try {
        Shopify.getCart((cart) => {
          window.updateCart(cart);
        });
      } catch (e) {
        /* silencioso */
      }
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }
    clearError() {
      if (this.errorEl) this.errorEl.hidden = true;
    }
  }
  if (!customElements.get("monte-seu-combo")) {
    customElements.define("monte-seu-combo", MonteSeuCombo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-stories"] && !Shopify.designMode) return;
  try {
    class ProductStories extends HTMLElement {
    constructor() {
      super();
      this.videos = this.querySelectorAll(".product-story");
      this.videos.forEach((video) =>
        video.addEventListener("click", () => {
          this.showPiP(video.dataset.index);
        })
      );
    }

    createForm() {
      const form = document.createElement("form");
      form.setAttribute("action", "/cart/add");
      form.setAttribute("method", "POST");
      form.setAttribute("data-product-id", window.product.id);
      form.setAttribute("enctype", "multipart/form-data");

      const inputId = document.createElement("input");
      inputId.setAttribute("type", "hidden");
      inputId.setAttribute("name", "id");
      inputId.setAttribute("value", window.product.variantId);

      const inputQt = document.createElement("input");
      inputQt.setAttribute("type", "hidden");
      inputQt.setAttribute("name", "quantity");
      inputQt.setAttribute("value", 1);

      const button = document.createElement("button");
      button.setAttribute("id", "gallery-product-add-to-cart-" + window.product.id);
      button.setAttribute("type", "submit");
      button.setAttribute("name", "add");
      button.setAttribute("data-btn-addtocart", "");
      button.setAttribute("data-available", window.product.available);
      button.classList = "product-form__submit button button--primary button--pip-form";
      button.insertAdjacentHTML(
        "beforeend",
        `
          <svg class="icon icon-cart w-h-24 m-lr-auto" width="31" height="29" viewBox="0 0 31 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.59155 7.18204C8.59155 3.47735 11.5948 0.474052 15.2995 0.474052C19.0041 0.474052 22.0073 3.47735 22.0073 7.18204" stroke="#6D6DB3" stroke-width="0.948107" stroke-miterlimit="10"></path>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9119 6.18918C25.8031 6.18918 27.4329 7.52225 27.8065 9.37617L30.5986 23.2281C30.5985 26.2803 28.1009 28.7781 25.0486 28.7781H5.55004C2.49773 28.7781 6.74325e-05 26.2803 0 23.2281L2.76627 9.38302C3.13746 7.52595 4.76833 6.18918 6.66233 6.18918H23.9119ZM17.9823 11.8511C16.7218 11.8446 15.4606 11.8341 14.2003 11.8526C12.2995 11.8803 10.9535 13.2546 10.9525 15.1415C10.9517 16.9085 10.9507 18.6759 10.9548 20.4428C10.9553 20.6581 10.9614 20.8796 11.0095 21.0879C11.315 22.4128 12.5046 23.2535 13.8488 23.1078C15.172 22.9645 16.1542 21.8646 16.1655 20.5006C16.1736 19.5158 16.1668 18.5305 16.1723 17.5456C16.1737 17.2788 16.1085 16.9144 16.5025 16.9111C16.927 16.9078 16.8556 17.2883 16.8586 17.5685C16.865 18.1913 16.8618 18.8144 16.8624 19.437C16.8633 20.2192 16.8511 21.0017 16.8685 21.7833C16.8847 22.5185 17.4303 23.0488 18.1055 23.0219C18.7711 22.9952 19.1223 22.5673 19.1227 21.7803V16.0446C19.1206 15.1911 18.7629 14.8298 17.9047 14.825C16.8325 14.8189 15.76 14.822 14.688 14.822C13.9877 14.8222 13.9059 14.9019 13.9051 15.5866C13.9038 17.2378 13.903 18.8892 13.9029 20.5401C13.9029 20.7899 13.867 21.0294 13.5521 21.0331C13.2616 21.0364 13.2105 20.8156 13.2105 20.579C13.2104 18.5803 13.2132 16.5817 13.2082 14.5831C13.2075 14.242 13.3848 14.1169 13.6936 14.1152C14.0993 14.1132 14.5052 14.1144 14.9109 14.1137C15.9395 14.1114 16.9686 14.1261 17.9967 14.1C18.6711 14.0827 19.1427 13.5379 19.1296 12.8644C19.1169 12.2165 18.7169 11.8547 17.9823 11.8511Z" fill="#6D6DB8"></path>
          </svg>
          ${window.product.available == "true" ? '<span class="btn-tooltip">Adicionar</span>' : '<span class="btn-tooltip">Esgotado</span>'}
        `
      );
      if (window.product.available != "true") {
        button.setAttribute("disabled", "disabled");
      }

      form.appendChild(inputId);
      form.appendChild(inputQt);
      form.appendChild(button);

      return form;
    }

    showPiP(activeIndex) {
      document.querySelector(".pip-gallery")?.remove();
      document.body.insertAdjacentHTML(
        "beforeend",
        `
<div class="pip-gallery is-mute expanded">
  <div class="pip-gallery--wrapper">
    <button class="close-pip-gallery"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/></svg></button>
    <div class="pip-gallery--navigation">
      <button class="navigate navigate-up" aria-label="Ver vídeo de cima">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon icon-up">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
        </svg>
      </button>
      <button class="navigate navigate-down" aria-label="Ver vídeo de baixo">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon icon-down">
          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
    </div>
    <button aria-label="Mudo/Som" class="pip-gallery--mute">
      <span class="mute">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="currentColor" 
          class="icon icon-mute" 
        >
          <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z" />
        </svg>
      </span>
      <span class="unmute">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="currentColor" 
          class="icon icon-unmute"
        >
          <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z" />
          <path d="M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z" />
        </svg>
      </span>
    </button>
    <div class="pip-gallery-carousel">
    </div>
  </div>
</div>
      `
      );

      const gallery = document.querySelector(".pip-gallery");
      const carousel = document.querySelector(".pip-gallery-carousel");
      this.videos.forEach((video, index) => {
        const controlsWrapper = document.createElement("div");
        controlsWrapper.classList.add("controls-wrapper");

        const shareBtn = document.createElement("a");
        shareBtn.setAttribute("target", "_blank");
        shareBtn.setAttribute("aria-label", "Compartilhar");
        shareBtn.setAttribute(
          "href",
          `http://wa.me/?text=Veja este produto que encontrei na Cola e Decora: ${window.product.title.replaceAll("&", "E").replaceAll("(", "").replaceAll(")", "")} - ${window.product.url}`
        );
        shareBtn.classList = "video-share";
        shareBtn.insertAdjacentHTML(
          "beforeend",
          `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon icon-send">
    <path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" />
  </svg>`
        );
        shareBtn.insertAdjacentHTML("beforeend", `<span class="btn-tooltip">Compartilhar</span>`);

        const form = this.createForm();

        controlsWrapper.appendChild(shareBtn);
        controlsWrapper.appendChild(form);

        const videoWrapper = document.createElement("div");
        videoWrapper.classList.add("video-wrapper");

        const videoEl = video.querySelector("video").cloneNode(true);

        const playBtn = document.createElement("button");
        playBtn.classList.add("play-wrapper");
        playBtn.insertAdjacentHTML(
          "beforeend",
          `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon icon-play">
  <path fill-rule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clip-rule="evenodd"></path>
</svg> 
        `
        );

        playBtn.addEventListener("click", function (e) {
          if (window.innerWidth > 1024 || (window.innerWidth <= 1024 && gallery.classList.contains("expanded"))) {
            videoWrapper.classList.toggle("playing");
            if (videoEl.paused) {
              videoEl.play();
            } else {
              videoEl.pause();
            }
          }
        });

        videoWrapper.appendChild(videoEl);
        videoWrapper.appendChild(controlsWrapper);
        videoWrapper.appendChild(playBtn);

        carousel.appendChild(videoWrapper);

        if (index == activeIndex) {
          videoWrapper.classList.add("playing");
          videoWrapper.classList.add("current");
          videoEl.play();
          videoEl.muted = true;
        }
      });

      const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
      carousel.setAttribute("data-current-index", activeIndex);
      carousel.setAttribute("data-max-index", this.videos.length - 1);
      carousel.style.transform = `translateY(-${activeIndex * videoHeight}px)`;

      const mute = document.querySelector(".pip-gallery .pip-gallery--mute");
      const navUp = document.querySelector(".pip-gallery .navigate-up");
      const navDown = document.querySelector(".pip-gallery .navigate-down");

      mute.addEventListener("click", function (e) {
        gallery.classList.toggle("is-mute");
        const currVideo = carousel.querySelector(".video-wrapper.current");
        currVideo.querySelector("video").muted = gallery.classList.contains("is-mute");
      });

      navUp.addEventListener("click", function (e) {
        e.preventDefault();
        const currIndex = carousel.dataset.currentIndex;
        const maxIndex = carousel.dataset.maxIndex;

        if (currIndex === "0") return;

        const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
        const currVideo = carousel.querySelector(".video-wrapper.current");
        currVideo.classList.remove("playing");
        currVideo.classList.remove("current");
        currVideo.querySelector("video").pause();

        const nextVideo = currVideo.previousElementSibling;
        nextVideo.classList.add("playing");
        nextVideo.classList.add("current");
        nextVideo.querySelector("video").play();
        nextVideo.querySelector("video").muted = gallery.classList.contains("is-mute");

        const newIndex = currIndex - 1;
        carousel.style.transform = `translateY(-${newIndex * videoHeight}px)`;
        carousel.setAttribute("data-current-index", newIndex);

        if (newIndex == 0) navUp.setAttribute("disabled", "disabled");
        if (newIndex < maxIndex) navDown.removeAttribute("disabled");
      });

      navDown.addEventListener("click", function (e) {
        e.preventDefault();
        const currIndex = carousel.dataset.currentIndex;
        const maxIndex = carousel.dataset.maxIndex;

        if (currIndex === maxIndex) return;

        const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
        const currVideo = carousel.querySelector(".video-wrapper.current");
        currVideo.classList.remove("playing");
        currVideo.classList.remove("current");
        currVideo.querySelector("video").pause();

        const nextVideo = currVideo.nextElementSibling;
        nextVideo.classList.add("playing");
        nextVideo.classList.add("current");
        nextVideo.querySelector("video").play();
        nextVideo.querySelector("video").muted = gallery.classList.contains("is-mute");

        const newIndex = Number(currIndex) + 1;
        carousel.style.transform = `translateY(-${newIndex * videoHeight}px)`;
        carousel.setAttribute("data-current-index", newIndex);

        if (newIndex == maxIndex) navDown.setAttribute("disabled", "disabled");
        if (newIndex >= 1) navUp.removeAttribute("disabled");
      });

      let startX, startY, endX, endY;
      let isSwiping = false; // Flag to track if a swipe is in progress

      carousel.addEventListener("touchstart", function (e) {
        const touchStart = e.touches[0];
        startX = touchStart.clientX;
        startY = touchStart.clientY;
        isSwiping = false; // Reset the swipe flag
      });

      carousel.addEventListener("touchmove", function (e) {
        if (window.innerWidth <= 1024) {
          const touchMove = e.touches[0];
          endX = touchMove.clientX;
          endY = touchMove.clientY;

          const deltaY = endY - startY;

          if (Math.abs(deltaY) > Math.abs(endX - startX)) {
            isSwiping = true;
            e.preventDefault();
          }
        }
      });

      carousel.addEventListener("touchend", function (e) {
        if (window.innerWidth <= 1024) {
          if (gallery.classList.contains("expanded")) {
            const touchEnd = e.changedTouches[0];
            endX = touchEnd.clientX;
            endY = touchEnd.clientY;

            const deltaX = endX - startX;
            const deltaY = endY - startY;

            if (Math.abs(deltaX) < Math.abs(deltaY)) {
              if (deltaY > 25) {
                navUp.dispatchEvent(new Event("click"));
              } else if (deltaY < -25) {
                navDown.dispatchEvent(new Event("click"));
              }
            }
          }
        }
        isSwiping = false;
      });

      carousel.addEventListener("touchcancel", function () {
        isSwiping = false;
      });

      function shrinkGallery(event) {
        if (gallery.contains(event.target) || this.contains(event.target)) return;
        if (window.innerWidth <= 1024) {
          gallery.classList.remove("expanded");
        }
      }

      function debounce(fn, wait = 150, { leading = false } = {}) {
        let t,
          didLead = false;

        return (...args) => {
          const callNow = leading && !t && !didLead;
          clearTimeout(t);

          if (callNow) {
            didLead = true;
            fn(...args);
          }

          t = setTimeout(() => {
            t = null;
            didLead = false;
            if (!leading) fn(...args);
            else fn(...args); // trailing too
          }, wait);
        };
      }

      function recalculateGalleryPosition() {
        const currIndex = carousel.dataset.currentIndex;
        const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
        carousel.style.transform = `translateY(-${currIndex * videoHeight}px)`;
        carousel.setAttribute("data-current-index", currIndex);
      }

      const closeBtn = document.querySelector(".close-pip-gallery");
      closeBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        document.querySelector(".pip-gallery")?.remove();
        document.removeEventListener("click", shrinkGallery.bind(this));
      });

      gallery.addEventListener("click", function (e) {
        if (window.innerWidth <= 1024) {
          gallery.classList.add("expanded");
        }
      });

      gallery.querySelectorAll(".product-form__submit, .video-share").forEach((btn) => {
        btn.addEventListener("click", () => {
          const currVideo = carousel.querySelector(".video-wrapper.current");
          currVideo.classList.remove("playing");
          currVideo.querySelector("video").pause();
        });
      });

      document.addEventListener("click", shrinkGallery.bind(this));
      window.addEventListener(
        "resize",
        debounce(
          () => {
            recalculateGalleryPosition();
          },
          200,
          { leading: true }
        )
      );
    }
  }

  customElements.define("product-stories", ProductStories);
  document.addEventListener("DOMContentLoaded", function () {
    let storiesBtn = document.querySelectorAll("[data-open-stories]");

    storiesBtn.forEach((item) => {
      item.addEventListener("click", function () {});
    });
  });

  function isVisibleInViewport(element, offset = 0) {
    const elementStyle = window.getComputedStyle(element);
    //Particular cases when the element is not visible at all
    if (
      elementStyle.height == "0px" ||
      elementStyle.display == "none" ||
      elementStyle.opacity == "0" ||
      elementStyle.visibility == "hidden" ||
      elementStyle.clipPath == "circle(0px at 50% 50%)" ||
      elementStyle.transform == "scale(0)" ||
      element.hasAttribute("hidden")
    ) {
      return false;
    }

    const rect = element.getBoundingClientRect();

    const bottomDelimiter = parseInt(window.innerHeight || document.documentElement.clientHeight);
    const rightDelimiter = parseInt(window.innerWidth || document.documentElement.clientWidth);

    return (
      rect.top >= -1 * offset &&
      rect.left >= 0 &&
      rect.bottom <= bottomDelimiter + offset &&
      rect.right <= rightDelimiter
    );
  }

  function checkWrapperVisibility() {
    const storiesWrappers = document.querySelectorAll(".product-stories-wrapper");
    storiesWrappers.forEach((storiesWrapper) => {
      if (storiesWrapper) {
        const videos = storiesWrapper.querySelectorAll(".product-story-thumb video");

        if (isVisibleInViewport(storiesWrapper, 100)) {
          videos.forEach((video) => video.play());
        } else {
          videos.forEach((video) => video.pause());
        }
      }
    });
  }

  function debounce(func, timeout = 300) {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this);
      }, timeout);
    };
  }

  const events = ["resize", "scroll", "load"];

  for (let event of events) {
    window.addEventListener(event, debounce(checkWrapperVisibility));
  }
  } catch(e) { console.error(e); }
})();

})();
